export const DISPLAY_TEXT = {
  WELCOME_TEXT: $localize`Admin Search`,
  SEARCH_TYPE: $localize`Search Type`,
  CRITERIA_1: $localize`Location Admin`,
  CRITERIA_2: $localize`User Admin`,
};
